exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#diagram2-5c-1 .simplest__structure-box{width:440px}#diagram2-5c-1 .simplest__structure-box .simplest__text-area{height:105px;overflow:hidden}#diagram2-5c-1 .submit{top:-35px;right:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/diagrams/5/5c/diagram2/diagram2.scss
// module id = 1423
// module chunks = 0